import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31623e12")

_pushScopeId("data-v-31623e12")
const _hoisted_1 = { class: "card mb-10 p-5 orders-header-area" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-4 d-flex flex-wrap align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "icon-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-chart-bar icon-size" })
], -1)
const _hoisted_5 = { class: "order-setting" }
const _hoisted_6 = {
  key: 0,
  class: "m-0 tableOpacity"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("rect", {
  x: "26%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "23%",
  height: "16"
}, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "m-0"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_11 = { class: "text-color-default" }
const _hoisted_12 = { class: "col-md-4 d-flex flex-wrap align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "icon-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-chart-line icon-size" })
], -1)
const _hoisted_14 = { class: "order-setting" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = {
  key: 0,
  class: "m-0 tableOpacity"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("rect", {
  x: "26%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "23%",
  height: "16"
}, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "m-0"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_21 = { class: "text-color-default" }
const _hoisted_22 = { class: "col-md-4 d-flex flex-wrap align-items-center" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "icon-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-money-bill-alt icon-size" })
], -1)
const _hoisted_24 = { class: "order-setting" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = {
  key: 0,
  class: "m-0 tableOpacity"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("rect", {
  x: "26%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "23%",
  height: "16"
}, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "m-0"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_31 = { class: "text-color-default" }
const _hoisted_32 = { class: "card" }
const _hoisted_33 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_34 = {
  key: 1,
  class: "badge badge-light-success"
}
const _hoisted_35 = {
  key: 2,
  class: "badge badge-light-danger"
}
const _hoisted_36 = { class: "badge badge-light-primary" }
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_38 = { class: "menu-item-wrapper" }
const _hoisted_39 = { class: "menu-item" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-cloud-download-fill" })
], -1)
const _hoisted_41 = { class: "menu-item" }
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-bug-fill" })
], -1)
const _hoisted_43 = {
  class: "modal fade",
  id: "pop_up_modal",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_44 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_45 = { class: "modal-content" }
const _hoisted_46 = { class: "modal-header" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_48 = {
  key: 0,
  class: "modal-body py-10 px-lg-17"
}
const _hoisted_49 = {
  key: 1,
  class: "modal-body py-10 px-lg-17"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AdvanceSearch = _resolveComponent("AdvanceSearch")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode("h4", null, _toDisplayString(`${_ctx.$t('message.TOTAL_JOBS')}`), 1),
            (_ctx.loader)
              ? (_openBlock(), _createBlock("p", _hoisted_6, [
                  _createVNode(_component_content_loader, {
                    width: "100%",
                    height: "16",
                    speed: 2,
                    primaryColor: "#ababab",
                    secondaryColor: "#cccccc"
                  }, {
                    default: _withId(() => [
                      _hoisted_7,
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock("p", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("strong", _hoisted_11, _toDisplayString(_ctx.dashboard?.total_jobs), 1)
                ]))
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_router_link, { to: { name: 'failed-jobs' } }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_14, [
                _createVNode("h4", _hoisted_15, _toDisplayString(_ctx.$t('message.FAILED_JOBS')), 1),
                (_ctx.loader)
                  ? (_openBlock(), _createBlock("p", _hoisted_16, [
                      _createVNode(_component_content_loader, {
                        width: "100%",
                        height: "16",
                        speed: 2,
                        primaryColor: "#ababab",
                        secondaryColor: "#cccccc"
                      }, {
                        default: _withId(() => [
                          _hoisted_17,
                          _hoisted_18
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createBlock("p", _hoisted_19, [
                      _hoisted_20,
                      _createVNode("strong", _hoisted_21, _toDisplayString(_ctx.dashboard?.total_failed), 1)
                    ]))
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode("div", _hoisted_24, [
            _createVNode("h4", _hoisted_25, _toDisplayString(_ctx.$t('message.RUNNING_JOBS')), 1),
            (_ctx.loader)
              ? (_openBlock(), _createBlock("p", _hoisted_26, [
                  _createVNode(_component_content_loader, {
                    width: "100%",
                    height: "16",
                    speed: 2,
                    primaryColor: "#ababab",
                    secondaryColor: "#cccccc"
                  }, {
                    default: _withId(() => [
                      _hoisted_27,
                      _hoisted_28
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock("p", _hoisted_29, [
                  _hoisted_30,
                  _createVNode("strong", _hoisted_31, _toDisplayString(_ctx.dashboard?.total_running), 1)
                ]))
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_32, [
      _createVNode(_component_AdvanceSearch, {
        filter: true,
        filterOption: _ctx.filterOption,
        status: _ctx.statusList,
        dateFilter: true,
        filterPlaceholder: 'message.SELECT',
        onSearch: _ctx.searchHandler,
        inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
        onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.get_failed_jobs(1, true))),
        onExportFile: _ctx.exportFile
      }, null, 8, ["filterOption", "status", "filterPlaceholder", "onSearch", "onExportFile"]),
      _createVNode(_component_Table, {
        columns: _ctx.columns,
        rows: _ctx.failed_jobs,
        pagination: _ctx.pagination,
        onHandleCurrentChange: _ctx.handleCurrentChange,
        padding: 5,
        loading: _ctx.loader
      }, {
        "cell-status": _withId(({row:item}) => [
          (item.status == 0)
            ? (_openBlock(), _createBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('message.RUNNING')), 1))
            : _createCommentVNode("", true),
          (item.status == 1)
            ? (_openBlock(), _createBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('message.SUCCESS')), 1))
            : _createCommentVNode("", true),
          (item.status == 2)
            ? (_openBlock(), _createBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('message.FAILED')), 1))
            : _createCommentVNode("", true)
        ]),
        "cell-finished_at": _withId(({row:item}) => [
          _createVNode("span", _hoisted_36, _toDisplayString(item?.finished_at ?? 'N/A'), 1)
        ]),
        "cell-actions": _withId(({row:item}) => [
          _createVNode("button", {
            class: "action-btn",
            type: "button",
            onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
          }, [
            _hoisted_37,
            _createVNode("div", {
              class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
            }, [
              _createVNode("div", _hoisted_38, [
                _createVNode("div", _hoisted_39, [
                  _createVNode("a", {
                    onClick: ($event: any) => (_ctx.getScenario(JSON.parse(item?.data), 'message.PAYLOAD')),
                    class: "menu-link me-1"
                  }, [
                    _hoisted_40,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('message.PAYLOAD')), 1)
                  ], 8, ["onClick"])
                ]),
                _createVNode("div", _hoisted_41, [
                  _createVNode("a", {
                    onClick: ($event: any) => (_ctx.getScenario(item.exception, 'message.EXCEPTION')),
                    class: "menu-link me-1"
                  }, [
                    _hoisted_42,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EXCEPTION')), 1)
                  ], 8, ["onClick"])
                ])
              ])
            ], 2)
          ], 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading"]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_43, [
          _createVNode("div", _hoisted_44, [
            _createVNode("div", _hoisted_45, [
              _createVNode("div", _hoisted_46, [
                _createVNode("h2", null, _toDisplayString(_ctx.$t(_ctx.popup_title)), 1),
                _hoisted_47
              ]),
              (_ctx.failed_scenarios)
                ? (_openBlock(), _createBlock("div", _hoisted_48, _toDisplayString(_ctx.failed_scenarios), 1))
                : (_openBlock(), _createBlock("div", _hoisted_49, _toDisplayString(_ctx.$t('message.NO_DATA_FOUND')), 1))
            ])
          ])
        ])
      ])
    ])
  ], 64))
})